<template>
  <div class="order_online">
    <div class="info">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)" @submit.native.prevent label-width="100px">
        <!-- <div>客户名称：{{$store.state.userInfo.companyName}}</div> -->
        <!-- <div></div> -->
        <el-row :gutter="10" style="margin-bottom:20px;">
          <el-col :span="6" class="ellipsis">
            <span :title="$store.state.user.defaultCompanyName">客户名称：{{$store.state.user.defaultCompanyName}}</span>
          </el-col>
          <el-col :span="16" v-if="rdmsInfo">
            <el-col :span="8">剩余套餐时长：{{rdmsInfo.availableUseDuration > 0?(rdmsInfo.availableUseDuration || 0): 0}}分钟</el-col>
            <el-col :span="8" v-if="rdmsInfo.availableUseDuration <= 0">已透支时长：{{rdmsInfo.usedDuration || 0}}分钟</el-col>
            <el-col :span="8" v-if="rdmsInfo.availableUseDuration <= 0">剩余透支时长：{{(rdmsInfo.overdraft - rdmsInfo.usedDuration) || 0}}分钟</el-col>
          </el-col>
          <el-col :span="2">
            <el-button size="small" @click="buyOpenHandle()" v-if="rdmsInfo && rdmsInfo.enterprise">购买</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="22">
            <el-form-item label="订单编号：" prop="orderCode">
              <el-input v-model="dataForm.orderCode" placeholder="请输入订单编号" :maxlength="18" oninput="value=value.replace(/[^\d]/g,'')" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="orderStatus">
              <el-select v-model="dataForm.orderStatus" placeholder="请选择" clearable>
                <el-option
                  v-for="(item) in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" size="small" @click="getDataList(1)">查询</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-form-item label="交易日期：">
            <el-date-picker v-model="dataForm.startTime" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" ></el-date-picker>
              -&nbsp;<el-date-picker v-model="dataForm.endTime" type="date" placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <el-table :data="dataList" border style="width: 100%">
      <el-table-column align="center" header-align="center" label="序号" type="index" width="50"></el-table-column>
      <el-table-column align="center" header-align="center" prop="orderCode" label="订单编号"></el-table-column>
      <el-table-column align="center" header-align="center" prop="renewalPackage" label="续费套餐"></el-table-column>
      <el-table-column property="payMoney" label="金额" width="105" align="center">
        <template slot-scope="scope">{{scope.row.payMoney|formatePrice}}</template>
      </el-table-column>
      <el-table-column align="center" header-align="center" prop="orderStatus" label="状态" width="180">
        <template slot-scope="scope">
          <span style="color:#CF555B"> {{$getDictLabel('ORDER_STATUS', scope.row.orderStatus)}} </span>
        </template>
      </el-table-column>
      <el-table-column align="center" header-align="center" prop="createTime" label="创建时间" width="180"></el-table-column>
      <el-table-column label="操作" align="center" width="80" header-align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="orderDetail(scope.row)"> 查看订单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
      style="margin-top:10px;"
      layout="prev, pager, next, total, jumper, slot"
      prev-text="上一页"
      next-text="下一页"
      @current-change="getDataList"
      :current-page="dataForm.page"
      :page-size="dataForm.limit"
      :pager-count="5"
      :total="dataForm.total">
    </el-pagination>
    <el-dialog :visible.sync="visibleGoods" width="70%">
      <el-table :data="commodityListData" border style="width: 100%">
        <el-table-column align="center" header-align="center" label="序号" type="index" width="50"></el-table-column>
        <el-table-column align="center" header-align="center" prop="title" label="商品名称"></el-table-column>
        <el-table-column align="center" header-align="center" prop="skuCode" label="商品编码"></el-table-column>
        <el-table-column align="center" header-align="center" prop="sellingPrice" label="商品价格">
          <template slot-scope="scope">{{scope.row.sellingPrice|formatePrice}}</template>
        </el-table-column>
        <el-table-column align="center" header-align="center" prop="model" label="商品属性">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.model}}</span>
          </template> -->
        </el-table-column>
        <el-table-column align="left" width="300" header-align="center" prop="summary" :show-overflow-tooltip="true" label="商品描述">
          <template slot-scope="scope">
            <div class="tooltip-div" v-if="scope.row.summary" v-html="decodeURIComponent(scope.row.summary)"></div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="detailHandle(scope.row)"> 查看详细 </el-button>
            <el-button type="text" size="mini" @click="buyNumHandle(scope.row)"> 购买 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        append-to-body
        :visible.sync="buyVisible"
        width="500px">
        <el-form :model="buyInfo" :rules="rules" ref="buyForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="购买数量" prop="buyCount">
            <el-input-number v-model="buyInfo.buyCount" :min="buyInfo.min"></el-input-number>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="buyHandle()">立即购买</el-button>
            <el-button @click="handleReset()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import { openOther } from '@/utils'
import { getAccessToken } from '@/utils/userInfo'
export default {
  name: 'onlineService', // 在线服务套餐
  data () {
    return {
      loading: false,
      rdmsInfo: null,
      statusList: [
        {
          value: '20',
          label: '待支付'
        },
        {
          value: '21',
          label: '已上传凭证'
        },
        {
          value: '29',
          label: '已确认收款'
        },
        {
          value: '59',
          label: '已完成'
        }
      ],
      dataForm: {
        orderCode: '',
        orderStatus: null,
        orderSource: '60',
        startTime: null,
        endTime: null,
        total: 0,
        page: 1,
        limit: 10
      },
      dataList: [], // 服务套餐列表
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      visibleGoods: false,
      commodityListData: [],
      buyVisible: false,
      buyInfo: {
        goodSpuId: '',
        goodSkuId: '',
        buyCount: 1,
        min: 1
      }
    }
  },
  computed: {
    rules () {
      return {
        buyCount: [
          { required: true, type: 'number', message: '购买数量不能为空' },
          { min: 1, max: 10, type: 'number', trigger: 'change', message: '购买数量只能输入1-10' }
          // { type: 'number', message: '购买数量必须为数字值' }
        ]
      }
    }
  },
  mounted () {
    this.getDataList(1)
  },
  methods: {
    getDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      this.loading = true
      let params = {
        ...this.dataForm
      }
      if (!params.orderStatus) {
        params.orderStatus = '0'
      }
      this.$request.get(`front/consumer/fictitiousorder/selectRdmsUserGateWays`, params)
        .then(res => {
          if (res) {
            this.rdmsInfo = res.rdmsInfo
            this.dataList = res.page.records || []
            this.dataForm.total = Number(res.page.total) || 0
          } else {
            this.rdmsInfo = null
            this.dataList = []
            this.dataForm.total = 0
          }
        })
        .catch(() => {
          this.rdmsInfo = null
          this.dataList = []
          this.dataForm.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 查看订单详细
    orderDetail (row) {
      this.$router.replace({
        name: 'rdmsOrderDetail',
        params: {
          id: row.orderId
        }
      })
    },
    buyOpenHandle () {
      this.commodityListData = []
      this.getGoodsList()
      this.visibleGoods = true
    },
    // 查找在线服务商品列表接口
    getGoodsList () {
      this.loading = true
      this.$request.get(`/front/consumer/fictitiousorder/selectOnlineRdmsCommodityList?resourceCode=RDMS`)
        .then(res => {
          this.commodityListData = res || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 跳转商品详情
    detailHandle (row) {
      openOther(`goodDetail?spuId=${row.spuId}&skuId=${row.skuId || ''}`)
    },
    // 选择商品数量
    buyNumHandle (row) {
      // this.buyInfo
      let hour = Number(row.model) || 1
      this.buyInfo.min = Math.floor((this.rdmsInfo.usedDuration / (hour * 60)) / 60.0) || 1
      if (this.buyInfo.min > 10) {
        this.$message.error('当前套餐需购买数量超过10，请更换套餐')
        return false
      }
      this.buyInfo.goodSpuId = row.spuId
      this.buyInfo.goodSkuId = row.skuId
      this.buyInfo.buyCount = 1
      this.buyVisible = true
    },
    // 购买
    buyHandle () {
      this.$refs['buyForm'].validate((valid) => {
        if (valid) {
          if (getAccessToken()) {
            if (this.$store.state.user.defaultCompanyId) {
              this.$router.push({
                name: 'createRdmsOrder',
                query: {
                  goodsNum: this.buyInfo.buyCount,
                  goodSpuId: this.buyInfo.goodSpuId,
                  goodSkuId: this.buyInfo.goodSkuId,
                  // enterprise: this.rdmsInfo.enterprise,
                  orderSource: '60'// 商品来源：60，在线；80，自助
                }
              })
            } else {
              this.$message.error('您还没有绑定公司,请联系贵公司的管理员')
            }
          } else {
            this.$router.push({ name: 'login' })
          }
        }
      })
    },
    // 取消购买
    handleReset () {
      this.buyVisible = false
      this.buyInfo.goodSpuId = ''
      this.buyInfo.goodSkuId = ''
      this.buyInfo.buyCount = 1
      this.buyInfo.min = 1
    }
  }
}
</script>
<style lang='scss' scoped>
.order_online{
  padding: 10px 20px;
}
</style>
